import { SystemField } from "./system-field";

export class ReasonCode extends SystemField{
     
    is_active?:number;
    reason_type?:string;
    code?:string;
    coa_id?:string;
    langs?:any;
}
export class ReasonCodeTranslation extends SystemField{
     
     lang_code?:string;
     description?:string;
     reason_code_id?:string;
}